module.exports = __webpack_public_path__ + "img/av306.33db95ec.png";